import React from 'react';
import { Voice } from '@/types/voice/voice';
import { Button } from '@/components/ui/button';
import VoiceCard from './VoiceCard';

interface VoiceGridProps {
  voices: Voice[];
  viewMode: 'list' | 'compact' | 'detailed';
  playingVoiceId: string | null;
  favoriteVoiceIds: Set<string>;
  visibleCount: number;
  totalCount: number;
  hasMore?: boolean;
  isTransitioning?: boolean;
  onPlayVoice: (voice: Voice) => void;
  onToggleFavorite: (voice: Voice) => void;
  onTryTextToSpeech: (voice: Voice) => void;
  onLoadMore: () => void;
}

export const VoiceGrid: React.FC<VoiceGridProps> = ({
  voices,
  viewMode,
  playingVoiceId,
  favoriteVoiceIds,
  visibleCount,
  totalCount,
  hasMore,
  isTransitioning = false,
  onPlayVoice,
  onToggleFavorite,
  onTryTextToSpeech,
  onLoadMore
}) => {
  const gridClassName = viewMode === 'list'
    ? "flex flex-col gap-1"
    : viewMode === 'compact'
    ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4"
    : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6";

  return (
    <>
      {/* Voice Grid */}
      <div
        className={`${gridClassName} transition-opacity duration-150 ${
          isTransitioning ? 'opacity-50' : 'opacity-100'
        }`}
      >
        {voices.slice(0, visibleCount).map((voice) => (
          <VoiceCard
            key={voice.id}
            voice={voice}
            viewMode={viewMode}
            isPlaying={playingVoiceId === voice.id}
            isFavorited={favoriteVoiceIds.has(voice.id)}
            onPlay={onPlayVoice}
            onToggleFavorite={onToggleFavorite}
            onTryText={onTryTextToSpeech}
          />
        ))}
      </div>

      {/* Load More Button */}
      {(hasMore || totalCount > visibleCount) && (
        <div className="flex justify-center mt-8">
          <Button
            onClick={onLoadMore}
            variant="outline"
            className="w-full max-w-xs"
          >
            Load More ({hasMore ? 'more available' : totalCount - visibleCount + ' remaining'})
          </Button>
        </div>
      )}
    </>
  );
};

export default VoiceGrid;